// @flow

import styled from 'styled-components';

import ClickableRow from '../../common/components/Forms/ClickableRow';
import RowIcon from '../../common/components/Forms/RowIcon';
import plusGrayIcon from '../../assets/svg/icons/plus-gray.svg';
import ContentText from '../../common/components/Text/ContentText';
import AnimatedRow from '../../common/components/Forms/AnimatedRow';

const Row = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  box-sizing: border-box;
`;

type Props = {
  delay: number,
  onClick: () => void
};

const AddNoteButton = ({ delay, onClick }: Props) => {
  return (
    <ClickableRow onClick={onClick}>
      <AnimatedRow noPaddingHorizontal delay={delay}>
        <RowIcon src={plusGrayIcon} />
        <Row>
          <ContentText themeColor="avatarBorderColor">Add a comment</ContentText>
        </Row>
      </AnimatedRow>
    </ClickableRow>
  );
};

export default AddNoteButton;
